import React, { useMemo } from 'react';

const LOGOS_CONFIG = {
  gruposanta: {
    src: '/img/logo_gruposanta.svg',
    alt: 'Grupo Santa',
    height: '3vh',
  },
  igesp: {
    src: '/img/logo_igesp.png',
    alt: 'IGESP',
    height: '4vh',
  },
  hsh: {
    src: '/img/logo_hsh.png',
    alt: 'Hospital Santa Helena',
    height: '5vh',
  },
	santacasasjc: {
		src: '/img/logo_santacasasjc.png',
		alt: 'SANTACASASJC',
		height: '5vh',
	},
	amaralcarvalho: {
		src: '/img/logo_amaralcarvalho.png',
		alt: 'Amaral Carvalho',
		height: '5vh',
	},
	aebel: {
		src: '/img/logo_aebel.png',
		alt: 'AEBEL',
		height: '5vh',
	},
	humanamagna: {
		src: '/img/logo_humanamagna.png',
		alt: 'Humana Magna',
		height: '5vh',
	},
	samur: {
		src: '/img/logo_samur.png',
		alt: 'SAMUR',
		height: '5vh',
	},
};

const LogoCliente = ({ backendUrl, style = {} }) => {
  const logo = useMemo(() => {
    const chave = Object.keys(LOGOS_CONFIG).find(key => backendUrl.includes(key));
    
    return chave ? LOGOS_CONFIG[chave] : null;
  }, [backendUrl])

  if (!logo) return null;
  
  return (
    <img
      src={logo.src}
      alt={logo.alt}
      style={{ height: logo.height, ...style }}
    />
  );
};

export default LogoCliente;
